
// open popup slider
var index;
class productMediaPopup {
  constructor() {
      this.overlay = null;
      this.modal = document.querySelector('#product-media-popup');
      this.enableZoomOnHover();
      this.modal.querySelector('.modal').addEventListener('click', (e) => {
        const path = e.composedPath();
        const clickedVideo = path.find(el => el instanceof Element && el.matches?.('swiper-slide video'));
        const clickedImage = path.find(el => el instanceof Element && el.matches?.('swiper-slide img'));
        const clickedIframe = path.find(el => el instanceof Element && el.matches?.('iframe'));
        const clickedArrow = path.find(el => el instanceof Element && el.matches?.('.swiper-button-next, .swiper-button-prev'));
        if (clickedVideo) {
          return;
        }
        if (clickedArrow) {
          // --- video play/pause logic ---
          const allVideos = this.modal.querySelectorAll('video');
          const activeSlide = this.modal.querySelector('.swiper-slide-active');
          const activeVideo = activeSlide ? activeSlide.querySelector('video') : null;
          allVideos.forEach((video, index) => {
            if (video === activeVideo) {
              if (video.paused) {
                video.play().catch(err => console.log("Play failed:", err));
              }
            } else {
              if (!video.paused) {
                video.pause();
                video.currentTime = 0;
              }
            }
          });
          // --- end video logic ---
          return;
        }

        // --- also handle slide change by drag/swipe ---
        const observer = new MutationObserver(() => {
          const allVideos = this.modal.querySelectorAll('video');
          const activeSlide = this.modal.querySelector('.swiper-slide-active');
          const activeVideo = activeSlide ? activeSlide.querySelector('video') : null;
          allVideos.forEach((video, index) => {
            if (video === activeVideo) {
              if (video.paused) {
                video.play().catch(err => console.log("Play failed:", err));
              }
            } else {
              if (!video.paused) {
                video.pause();
                video.currentTime = 0;
              }
            }
          });
        });

        // watch for active slide class changes
        const swiperWrapper = this.modal.querySelector('.swiper-wrapper');
        if (swiperWrapper) {
          observer.observe(swiperWrapper, { attributes: true, subtree: true, attributeFilter: ['class'] });
        }
        if (!clickedImage && !clickedIframe && !clickedArrow) {
          this.closeModal();
        }
      });

  }

  closeModal() {
    document.querySelector("#product-media-popup .modal").classList.remove("open");
    document.body.classList.remove('scroll-fixed');
    SiteOverlay.prototype.hideOverlay();
    window.zoomMediaLoaded = false;
    // this.modal.querySelector('[data-zoomMediaContainer]').innerHTML = '';
  }

  enableZoomOnHover=()=>{
      const images = document.querySelectorAll('.product-images-wrapper .image-zoom');
      images.forEach(image => {
          image.onclick = (event) => {
            event.preventDefault();
              this.clicked_image = event.currentTarget;
              this.clicked_media_id = this.clicked_image.getAttribute('data-media-id');
              this.openZoomModal();
              if(this.clicked_media_id != null){
                setTimeout(() => {
                    const swiperInstance = this.modal.querySelector('swiper-container').swiper;
                    console.log(".product-modal-slider swiper-slide[data-mediaid='"+this.clicked_media_id+"']")
                    // Find the index matching the clicked media
                    let targetIndex = parseInt(document.querySelector(".product-modal-slider swiper-slide[data-mediaid='"+this.clicked_media_id+"']").getAttribute("data-index")) - 1;
                    swiperInstance.slideTo(targetIndex);
                }, 300);
              }
          };
      });
  }

  buildProductMediaUI=()=>{
    let productMedia = window.globalSpace.product.media;
    if(!productMedia) return;

    const variantTitle = window.currentVariantTitle;
    let allSlides = [];

    const filteredMedia = productMedia.filter(media => {
        if (media.media_type !== 'image') return false;
        const altText = (media.alt || window.productTitle).toLowerCase().trim();
        return altText === variantTitle || altText.split('||').some(v => v.trim() === variantTitle);
    });

    filteredMedia.forEach((media, i) => {
        allSlides.push({
            type: 'image',
            id: media.id,
            html: `<swiper-slide class="text-center" data-index="${allSlides.length}" data-media-id="${media.id}" role="treeitem">
                        <div class="align-items-center d-flex h-100 justify-content-center">
                          <img src="${media.src}" alt="${media.alt}" width="${media.width}" height="${media.height}">
                        </div>
                   </swiper-slide>`
        });
    });

    // Add custom videos
    const customVideoBlocks = document.querySelectorAll('.pdp-media-block[data-video-url]');
    customVideoBlocks.forEach((block, i) => {
        const videoUrl = block.getAttribute('data-video-url');
        const mediaId = block.getAttribute('data-media-id') || `custom-video-${i}`;
        allSlides.push({
            type: 'video',
            id: mediaId,
            html: `<swiper-slide class="text-center" data-index="${allSlides.length}" data-media-id="${mediaId}" role="treeitem" data-video-url="${videoUrl}" data-video-type="custom">
                        <div class="align-items-center d-flex h-100 justify-content-center position-relative">
                            <video src="${videoUrl}" width="100%" height="100%" autoplay loop muted playsinline></video>
                        </div>
                   </swiper-slide>`
        });
    });

    // Combine all HTML
    const finalHTML = allSlides.map(s => s.html).join('');
    let sliderHTML = `<swiper-container class="swiper-container light-arrow hide_arrow d-block w-100 h-100"
                        slides-per-view="1" speed="500" loop="false" threshold="20" space-between="30"
                        grab-cursor="true" navigation="true">
                        ${finalHTML}
                      </swiper-container>`;
    this.modal.querySelector('[data-zoomMediaContainer]').innerHTML = sliderHTML;

    this.openZoomModal(allSlides);

    window.zoomMediaLoaded = true;
  }

  openZoomModal = (allSlides) => {
    setTimeout(() => {
        const modal = document.querySelector("#product-media-popup .modal");

        document.body.classList.add('scroll-fixed');
        SiteOverlay.prototype.showOverlay();
        modal.classList.add("open");
    }, 320); // Delay in milliseconds
}
}

typeof productMediaPopup !== 'undefined' && new productMediaPopup();


//Popup Video pause play JS start

document.addEventListener('DOMContentLoaded', function() {
  const popup = document.getElementById('product-media-popup');
  if (!popup) {
    return;
  }
  const videoStates = new Map();
  // Check if modal is currently open
  function isModalOpen() {
    const modal = popup.querySelector('.modal');
    return modal && modal.classList.contains('open');
  }
  // Initialize video tracking
  function initVideoTracking() {
    const videos = popup.querySelectorAll('video');
    videos.forEach((video, index) => {
      const videoId = `video_${index}`;
      videoStates.set(videoId, {
        userPaused: false,
        completed: false,
        element: video
      });
      video.addEventListener('pause', function() {
        if (isModalOpen()) {
          const state = videoStates.get(videoId);
          if (!video.ended && !state.completed) {
            state.userPaused = true;
          }
        }
      });
      // Listen for user play
      video.addEventListener('play', function() {
        if (isModalOpen()) {
          const state = videoStates.get(videoId);
          state.userPaused = false;
          state.completed = false;
        } else {
          video.pause();
          video.currentTime = 0;
        }
      });
      // Listen for video end
      video.addEventListener('ended', function() {
        if (isModalOpen()) {
          const state = videoStates.get(videoId);
          state.completed = true;
          state.userPaused = false;
        }
      });
      // Listen for seeking
      video.addEventListener('seeked', function() {
        if (isModalOpen()) {
          const state = videoStates.get(videoId);
          if (video.currentTime < video.duration * 0.95) {
            state.completed = false;
          }
        }
      });
    });
  }
  // Function to stop all videos when modal closes
  function stopAllVideos() {
    const videos = popup.querySelectorAll('video');
    videos.forEach((video, index) => {
      const videoId = `video_${index}`;
      const state = videoStates.get(videoId);
      if (!video.paused) {
        video.pause();
        video.currentTime = 0;
      }
      if (state) {
        state.userPaused = false;
        state.completed = false;
      }
    });
  }
  // Function to play videos when modal opens
  function playVideosIntelligently() {
    if (!isModalOpen()) return;
    const activeSlideVideo = popup.querySelector('.swiper-slide-active video');
    if (!activeSlideVideo) return;
    const allVideos = popup.querySelectorAll('video');
    let videoIndex = -1;
    allVideos.forEach((video, index) => {
      if (video === activeSlideVideo) videoIndex = index;
    });
    if (videoIndex >= 0) {
      const videoId = `video_${videoIndex}`;
      const state = videoStates.get(videoId);
      if (state && !state.userPaused && !state.completed && activeSlideVideo.paused) {
        activeSlideVideo.play().catch(error => {
        });
      }
    }
  }
  // Main function to check modal state changes
  function checkModalStateChange() {
    if (isModalOpen()) {
      playVideosIntelligently();
    } else {
      stopAllVideos();
    }
  }
  // MutationObserver
  const observer = new MutationObserver(function(mutations) {
    let shouldCheck = false;
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (mutation.target.classList.contains('modal')) {
          shouldCheck = true;
        }
        if (mutation.target === popup || popup.contains(mutation.target)) {
          shouldCheck = true;
        }
      }
    });
    if (shouldCheck) {
      setTimeout(checkModalStateChange, 10);
    }
  });
  observer.observe(popup, {
    attributes: true,
    attributeFilter: ['class'],
    subtree: true
  });
  
  // Additional observer
  const additionalObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes') {
        const attrName = mutation.attributeName;
        if (attrName === 'style' || attrName === 'aria-hidden') {
          const isVisible = window.getComputedStyle(popup).display !== 'none';
          const isAriaHidden = popup.getAttribute('aria-hidden') === 'true';
          if (!isVisible || isAriaHidden) {
            stopAllVideos();
          }
        }
      }
    });
  });
  additionalObserver.observe(popup, {
    attributes: true,
    attributeFilter: ['style', 'aria-hidden']
  });
  
  // Backup interval
  setInterval(() => {
    if (!isModalOpen()) {
      const playingVideos = Array.from(popup.querySelectorAll('video')).filter(v => !v.paused);
      if (playingVideos.length > 0) {
        stopAllVideos();
      }
    }
  }, 500);
  
  // Escape key listener
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      setTimeout(() => {
        if (!isModalOpen()) {
          stopAllVideos();
        }
      }, 100);
    }
  });
  // ✅ Outside click close popup logic + video toggle
  document.addEventListener('click', function(e) {
    if (isModalOpen()) {
      const clickedVideo = e.target.closest('video');
      if (clickedVideo) {
        if (clickedVideo.paused) {
          clickedVideo.play().catch(err => console.log("Play failed:", err));
        } else {
          clickedVideo.pause();
        }
        return; // Dont close popup
      }
      popup.querySelector('.modal')?.classList.remove('open');
    }
  });
  // Initialize
  setTimeout(() => {
    initVideoTracking();
    checkModalStateChange();
  }, 500);

  
  // ✅ Video click → toggle play/pause (prevent popup close)
  popup.querySelectorAll('video').forEach(video => {
    video.addEventListener('click', function(e) {
      e.stopPropagation(); // popup bandh na thay
      if (video.paused) {
        video.play().catch(err => console.log("Play failed:", err));
      } else {
        video.pause();
      }
    });
  });
});

// For mobile slides change pause video
const modal = document.querySelector("#product-media-popup .modal"); 
if (modal){
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === "class") {
        if (modal.classList.contains("open")) {
          const swiperEl = modal.querySelector(".swiper-container");
          if (swiperEl && swiperEl.swiper) {
            const swiperInstance = swiperEl.swiper;
            swiperInstance.on("slideChange", () => {
              const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
              const allVideos = modal.querySelectorAll("video");
              if (allVideos.length === 0) {
                return;
              }
              allVideos.forEach((vid) => {
                if (activeSlide.contains(vid)) {
                  vid.play().catch(err => console.log("Play fail:", err));
                } else {
                  vid.pause();
                  vid.currentTime = 0;
                }
              });
            });
          }
        } else {
          const allVideos = modal.querySelectorAll("video");
          allVideos.forEach((vid) => {
            vid.pause();
            vid.currentTime = 0;
          });
        }
      }
    });
  });
  observer.observe(modal, { attributes: true });
}
//Popup Video pause play JS end


